jsidea.ready(() => {});
